if (!String.prototype.includes) {
  // eslint-disable-next-line
  String.prototype.includes = function() {
      return String.prototype.indexOf.apply(this, arguments) !== -1;
  };
}


// WEBPACK FOOTER //
// ./src/utils/polyfills/includes.js